import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Button, IconButton, Tooltip } from '@mui/material';
import { useContext } from 'react';

import { BUTTON_RADIUS } from '~/theme';

import { UploadDocumentDialogFlowContext } from './UploadDocumentDialogFlow';

type Variant =
  /** Labelled button in the global bar. */
  | 'bar'
  /** Icon-only, for the phone bar. */
  | 'compact'
  /** The primary action, at the top of the navigation rail. */
  | 'rail';

const UploadDocumentButton = ({
  variant = 'bar',
  collapsed = false,
}: {
  variant?: Variant;
  collapsed?: boolean;
}) => {
  const { start } = useContext(UploadDocumentDialogFlowContext);

  if (variant === 'compact') {
    return (
      <IconButton
        aria-label="Upload Document"
        onClick={() => start()}
        sx={{
          color: 'primary.contrastText',
          backgroundColor: 'primary.main',
          '&:hover': { backgroundColor: 'primary.dark' },
        }}
      >
        <UploadFileIcon />
      </IconButton>
    );
  }

  if (variant === 'rail') {
    const button = (
      <Button
        variant="contained"
        color="primary"
        onClick={() => start()}
        aria-label="Upload Document"
        startIcon={collapsed ? undefined : <UploadFileIcon />}
        sx={{
          height: 44,
          minWidth: 0,
          width: '100%',
          px: collapsed ? 0 : 1.5,
          borderRadius: `${BUTTON_RADIUS}px`,
          textTransform: 'none',
          fontSize: 14,
          fontWeight: 600,
          whiteSpace: 'nowrap',
          boxShadow: '0 1px 3px rgba(16, 24, 40, 0.16)',
          '&:hover': { boxShadow: '0 2px 6px rgba(16, 24, 40, 0.22)' },
        }}
      >
        {collapsed ? <UploadFileIcon /> : 'Upload Document'}
      </Button>
    );

    return collapsed ? (
      <Tooltip title="Upload Document" placement="right">
        {button}
      </Tooltip>
    ) : (
      button
    );
  }

  return (
    <Button variant="contained" color="primary" onClick={() => start()}>
      Upload Document
    </Button>
  );
};
export default UploadDocumentButton;
